import {IStopListState,IStopListActionTypes,IStopListActionCreator} from 'models/IStopListState';

const initialState:IStopListState[] = []

const reducer = (state = initialState, { type, payload }: IStopListActionCreator) => {
    switch (type) {
      case IStopListActionTypes.FETCH_STOPS_LIST_REQUEST:
        return {
            ...state,
            data:[],
        }
      case IStopListActionTypes.FETCH_STOPS_LIST_SUCCESS:
        return {
          ...state,
          data: payload
        }
      default:
        return state;
    }
  };
  
  export default reducer;